import React from "react";

const About = () => {
	return (
		<div className="max-w-3xl mx-auto p-6 text-gray-800">
			<h1 className="text-2xl font-bold mb-4">About MaterialLogs.com</h1>
			<p className="mb-4">
				MaterialLogs.com is a project born out of passion and necessity. As an independent developer, crafter, and maker, I know firsthand the challenges of keeping track of materials, projects, and inventory. I built this platform to create a seamless and intuitive way to manage everything in one place.
			</p>

			<h2 className="text-lg font-semibold mt-6">Built by a Maker, for Makers</h2>
			<p className="mb-4">
				Being deeply involved in both **development and hands-on crafting**, I understand the frustration of losing track of supplies, forgetting where materials were sourced, or running out of something mid-project. I wanted a tool that was **simple, effective, and tailored for makers, artisans, and creators**—so I built it.
			</p>

			<h2 className="text-lg font-semibold mt-6">Independent Development & Hard Work</h2>
			<p className="mb-4">
				As an **independent developer**, every feature and line of code in MaterialLogs.com has been thoughtfully crafted. I balance development with my passion for making, testing the tool in real-world scenarios to ensure it truly helps creators **stay organized without the hassle of complex software**.
			</p>

			<h2 className="text-lg font-semibold mt-6">Support My Work</h2>
			<p className="mb-4">
				If you find MaterialLogs.com helpful, please consider supporting my work. Every donation goes toward improving the platform, maintaining the site, and adding new features to make this tool even better for the maker community.
			</p>

			<div className="mt-4">
				<p className="font-semibold">Donate via Email Transfer:</p>
				<p className="text-blue-500">donation@materiallogs.com</p>
			</div>

			<div className="mt-4">
				<p className="font-semibold">Donate via Stripe:</p>
				<a
					href="https://donate.stripe.com/14keWSakD1dxgLeeUU"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-500 hover:underline"
				>
					Click here to donate via Stripe
				</a>
			</div>

			<p className="text-sm text-gray-600 mt-6">
				Thank you for your support! Every contribution helps keep MaterialLogs.com running and growing.
			</p>
		</div>
	);
};

export default About;
